module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-491.0988149.woff2";